import { createRouter, createWebHashHistory } from 'vue-router'
import { useAuthStore } from '@/stores/auth'
import type { ProductKind } from '@/types/product'
import type { OrderKind } from '@/types/order'
import { routes } from './routes'

declare module 'vue-router' {
  interface RouteMeta {
    title?: string
    public?: boolean
    requiresAuth?: boolean
    permission?: string
    menuKey?: string
    hidden?: boolean
    productKind?: ProductKind
    orderKind?: OrderKind
  }
}

const router = createRouter({ history: createWebHashHistory(), routes })

router.beforeEach((to) => {
  const auth = useAuthStore()
  const requiresAuth = to.matched.some((record) => record.meta.requiresAuth)
  if (requiresAuth && !auth.isAuthenticated)
    return { path: '/login', query: { redirect: to.fullPath } }
  if (to.path === '/login' && auth.isAuthenticated) return '/'
  const permission = to.meta.permission
  if (permission && !auth.hasPermission(permission)) return '/403'
  return true
})

router.afterEach((to) => {
  document.title = to.meta.title ? `${to.meta.title} - 五色惠商家后台` : '五色惠商家后台'
})

export default router
